import Text from "ab-text";
import Link from "ab-link";
import Tag from "ab-tag";

import "./ab-highlights.scss";

const Highlights = ({
  image,
  imagemobile,
  title,
  description,
  linkText,
  href,
  tag,
  className = "",
  classname = "",
  animated,
  link,
}) => {
  return (
    <div className={`ab-highlights ${className || classname || ""}`}>
      <div className="details">
        {tag ? <Tag>{tag}</Tag> : null}
        <Text element="h2" animated={animated}>
          {title}
        </Text>
        <Text>{description}</Text>
        {link ? (
          <Link
            prefetch={false}
            text={linkText || link?.title}
            href={href || link?.url}
            target={link?.target}
          />
        ) : null}
      </div>

      <picture className="image">
        <source srcSet={imagemobile?.mediaItemUrl} media="(max-width: 850px)" />
        <img src={image?.mediaItemUrl || image} loading="lazy" alt={title} />
      </picture>

      <hr />
    </div>
  );
};

export default Highlights;
